import { listEnrollments } from '@/lib/api'
import { useAsyncData } from '@/lib/useAsyncData'

export function StudentCoursesPage() {
  const { data, error, loading } = useAsyncData(listEnrollments, [])

  return (
    <div className="space-y-6 p-8">
      <h1 className="text-2xl font-bold text-slate-800">My Courses</h1>
      {loading && <p className="text-sm text-slate-500">Loading…</p>}
      {error && <p className="rounded-xl bg-red-50 px-4 py-3 text-sm text-red-700">{error}</p>}
      <div className="grid gap-4 md:grid-cols-2">
        {(data || []).map((e) => (
          <article key={e.id} className="rounded-2xl border border-slate-100 bg-white p-5 shadow-sm">
            <p className="text-xs font-bold tracking-wider text-blue-600 uppercase">{e.course_details.code}</p>
            <h2 className="mt-1 text-lg font-bold text-slate-800">{e.course_details.title}</h2>
            <p className="mt-2 text-xs text-slate-500">
              {e.semester_name || 'Semester'} · {e.course_details.credits} credits
            </p>
          </article>
        ))}
      </div>
      {!loading && (data || []).length === 0 && (
        <p className="text-sm text-slate-500">You are not enrolled in any courses yet.</p>
      )}
    </div>
  )
}
